import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import '../static/ZoomButton.css';

const ZoomButton = ({ show, zoomUrl }) => {
  const { t } = useLanguage();
  if (!show) return null;

  return (
    <div className="service-zoom-footer">
      <a
        href={zoomUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="service-zoom-action-bar"
      >
        <span className="zoom-action-left">
          <i className="fas fa-video"></i>
          <span className="zoom-action-text">{t('zoom.actionText')}</span>
        </span>
        <i className="fas fa-arrow-right zoom-action-arrow"></i>
      </a>
    </div>
  );
};

export default ZoomButton;
